module.exports = __webpack_public_path__ + "img/activities.4b10a7b5.svg";